import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "auth_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); };
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Repli robuste au cookie tiers (SameSite=None souvent dropé en iframe de preview) :
// on envoie aussi le jeton de session en en-tête Authorization: Bearer.
api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Tout endpoint de connexion/inscription renvoie un `token` -> on le mémorise automatiquement.
api.interceptors.response.use((res) => {
  const t = res?.data?.token;
  if (t) setToken(t);
  return res;
});

export default api;
export { BACKEND_URL };
